import { ListItem } from 'src/components/ListItem';
import { Scroller } from 'src/components/Scroller';
import { Stack } from 'src/components/Stack';
import { TextField, TextFieldProps } from 'src/components/TextField';

interface SelectFilterConfig {
  field: string;
  label: string;
  value: any;
  setValue: (newVal: any, close?: boolean) => void;
  showDefaultOption?: boolean;
  options?: TextFieldProps['options'];
  valueOnly?: boolean;
  showList?: boolean;
  disabled?: boolean;
  onChange?: (newVal: any) => void;
}

export const SelectFilter: React.FC<SelectFilterConfig> = ({
  label,
  showDefaultOption = true,
  options,
  value,
  setValue,
  valueOnly,
  showList,
  disabled,
  onChange,
}) => {
  if (valueOnly) {
    const selectedOption = options?.find((opt) => opt.value === value);
    return selectedOption?.label || value;
  }

  if (!options || !options.length) {
    return null;
  }

  return (
    <>
      <TextField
        label={label}
        onChange={(e) => {
          setValue(e.target.value, true);
          onChange && onChange?.(e.target.value);
        }}
        value={value ?? ''}
        options={[
          ...(showDefaultOption ? [{ value: '', label: 'Any' }] : []),
          ...options,
        ]}
        disabled={disabled}
      />
      {showList && !disabled && (
        <Scroller direction="column" sx={{ maxHeight: '200px', mt: 1 }}>
          <Stack spacing={1}>
            {options.map((option) => (
              <ListItem
                key={option.value}
                clickable
                rounded
                onClick={() => setValue(option.value)}
                selected={value === option.value}
                primary={option.label}
              ></ListItem>
            ))}
          </Stack>
        </Scroller>
      )}
    </>
  );
};
